import Layout from '@layout/Index'

export const coverEstimate = [
  {
    path: '/cover-estimate',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "CoverUploadTable" */ './pages/CoverUploadTable.vue'),
        name: '覆盖预估',
        meta: {
          title: '覆盖预估',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/cover-estimate/cover-estimate.route.js